import React from 'react';
import { classNames, initialsOf } from '../../utils/format';

export default function Avatar({ firstName, lastName, name, size = 'sm', tone = 'blue' }) {
  let label = '';
  if (firstName || lastName) label = initialsOf(firstName, lastName);
  else if (name) label = initialsOf(...String(name).split(/\s+/).filter(Boolean));
  return <span className={classNames(`avatar avatar-${size}`, `avatar--${tone}`)}>{label || '·'}</span>;
}
